import { AGENCY_URL_PATTERN, MARVIN_AGENCY_URL_PATTERN } from '../common/constants'

/**
 * Determines if the current context is an agency portal based on hostname
 * @param hostname - The hostname to check against URL patterns
 * @returns boolean indicating if this is an agency portal
 */
export const isAgencyPortal = (hostname: string): boolean => {
  return AGENCY_URL_PATTERN.test(hostname) || MARVIN_AGENCY_URL_PATTERN.test(hostname)
}
